module.exports = __webpack_public_path__ + "static/media/tick-hexagon.44687e20.svg";